import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import React, { useEffect, useRef } from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import * as styles from './DataDirect.module.scss';

gsap.registerPlugin(ScrollTrigger);
gsap.defaults({
  duration: 0.25,
});

export default function DataDirect({ containerRef, content }) {
  const trigger = useRef();
  const tl = useRef();

  useEffect(() => {
    // GSAP stuff
    const ctx = gsap.context(() => {
      gsap.set(['#image-2', '#image-3'], {
        yPercent: 50,
      });

      tl.current = gsap
        .timeline({
          scrollTrigger: {
            trigger: trigger.current,
            start: () => 'top center',
            scrub: 3,
          },
        })
        .to('#image-1', {
          opacity: 0,
          yPercent: -50,
          delay: 2,
        })
        .to(
          '#image-2',
          {
            opacity: 1,
            yPercent: 0,
          },
          '<+=0.5'
        )
        .to(
          '#image-2',
          {
            opacity: 0,
            yPercent: -50,
          },
          '>+=2'
        )
        .to(
          '#image-3',
          {
            opacity: 1,
            yPercent: 0,
          },
          '<+=0.5'
        );
    }, containerRef);

    return () => ctx.revert();
  }, [containerRef]);

  return (
    <div className={styles.animation} ref={trigger}>
      {content.map((section, i) => (
        <div id={`image-${i + 1}`} key={section.id}>
          <ContentfulImage imageFragment={section.image} lazy={true} />
        </div>
      ))}
    </div>
  );
}
